import { Author} from "src/models/CoAuthor";
import { JsonProperty } from "json2typescript";

export class PublicationAuthor {
    @JsonProperty("author_id", String)
    public author_id: string = "";
    
    @JsonProperty("first_name", String)
    public first_name: string = "";

    @JsonProperty("last_name", String)
    public last_name: string = "";

    @JsonProperty("affiliation_id", String)
    public affiliation_id: string = "";
}

export class PublicationListItem {

    @JsonProperty("source_id", String)
    public readonly source_id: string;

    @JsonProperty("abstract", String)
    public readonly abstract: string;

    @JsonProperty("title", String)
    public readonly title: string;

    @JsonProperty("scopus_id", String)
    public readonly scopus_id: string;

    @JsonProperty("authors", [])
    public readonly authors: PublicationAuthor[] = [];

    @JsonProperty("pub_date", String)
    public readonly pub_date: string;

    @JsonProperty("source_name", String)
    public readonly source_name: string;

    @JsonProperty("citedby_count", String)
    public readonly citedby_count: number;

    @JsonProperty("scopus_self_link", String)
    public readonly scopus_self_link: string = "";

    @JsonProperty("doi", String)
    public readonly doi: string = "";

    @JsonProperty("bibtex", String)
    public readonly bibtex: string = "";
}


// WEBPACK FOOTER //
// ./src/models/PublicationListItem.ts